// eslint-disable-next-line max-classes-per-file
import { ResponseHotelPresenter } from "./getHotelAvailableInterface";

export interface RequestHotelCountrySlug {
  countrySlug: string;
}

// export interface HotelDetail {
//   id: number;
//   hotelName: string;
//   hotelSlug: string;
//   hotelStar: number;
//   countryName: string;
//   countrySlug: string;
//   countryUrl: string;
//   cityName: string;
//   citySlug: string;
//   cityUrl: string;
//   areaName: string;
//   areaSlug: string;
//   areaUrl: string;
//   latitude: number;
//   longitude: number;
//   isFreeWifi: number;
//   isFreeParking: number;
//   isFavourite: number;
//   facilities: string[];
//   facilitiesDetail: FacilitiesDetail[];
//   images: string[];
//   review: Review;
//   isGreenCertificate: boolean;
//   greenCertifications: GreenCertification[];
// }

// export interface FacilitiesDetail {
//   groupId: number;
//   groupName: string;
//   details: Detail[];
// }

// export interface Detail {
//   id: number;
//   name: string;
//   image: string;
// }

// export interface Review {
//   rating: number;
//   text_rating_detail: string;
//   num_reviews: number;
// }

// export interface GreenCertification {
//   id: number;
//   nameEn: string;
//   nameTh: string;
// }

class BreadcrumbHotelPresenter {
  areaName: string | null;

  areaSlug: string | null;

  cityName: string | null;

  citySlug: string | null;

  countryName: string | null;

  countrySlug: string | null;

  constructor(responseData: any) {
    this.areaName = responseData.areaName || null;
    this.areaSlug = responseData.areaSlug || null;

    this.cityName = responseData.cityName || null;

    this.citySlug = responseData.citySlug || null;

    this.countryName = responseData.countryName || null;

    this.countrySlug = responseData.countrySlug || null;
  }
}

export class HotelGreenCertificatePresenter {
  status: boolean;

  hotels: ResponseHotelPresenter[];

  breadcrumbs: BreadcrumbHotelPresenter;

  constructor(responseData: HotelGreenCertificatePresenter) {
    this.status = responseData.status || false;
    this.hotels = (responseData.hotels || []).map(
      (hotel: any) => new ResponseHotelPresenter(hotel),
    );
    this.breadcrumbs = new BreadcrumbHotelPresenter(responseData.breadcrumbs);
  }
}
